import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormToolbar = _resolveComponent("FormToolbar")!
  const _component_FormComponent = _resolveComponent("FormComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_FormToolbar, {
      onSubmitForm: _ctx.submitFormAction,
      onBreadcrumbs: ($event: any) => ([])
    }, null, 8, ["onSubmitForm"]),
    _createVNode(_component_FormComponent, {
      ref: "formComponent",
      id: _ctx.route.params.id ?? '0',
      routeKey: _ctx.route.meta.key
    }, null, 8, ["id", "routeKey"])
  ], 64))
}